import React, { useState } from 'react'
import { CircularProgress, Button, Dialog, DialogContent, DialogTitle, DialogActions } from '@material-ui/core';
import { DropzoneArea } from "material-ui-dropzone";
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import PageLoader from './PageLoader';
import { useSnackbar } from 'notistack';
import { globalExportService, globalFileUploadService } from '../../utils/globalApiServices';
import { checkApiStatus, downloadFileType } from '../../utils';
import { trackActivity } from '../../utils/mixpanel';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
function ImportFormat({ match, toggleModalFn, getResponseBack, title, moduleType, moduleName, assetType, fleet, revampSample }) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [file, setFile] = useState([]);
    const [isLoading, setLoading] = useState(false)

    const downloadSample = (query) => {
        globalExportService(`camo/${moduleType}/sample-file/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    downloadFileType(response.data, `${moduleName}`, 'xlsx')
                    enqueueSnackbar("Sample File Download Successfully", { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } })
                } else {
                    enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } })
                }
            });
    }

    const importFile = () => {
        var formData = new FormData();
        formData.append('file', file[0])
        setLoading(true);
        globalFileUploadService(fleet ? `camo/${moduleType}/import/` : `camo/${moduleType}/${match?.params?.asset}/${match?.params?.assetType}/import/`, formData)
            .then(response => {
                setLoading(false); toggleModalFn(); getResponseBack()
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                    trackActivity("Import Success - Airworthiness Management", {
                        event_type: 'Attachment Success',
                        page_title: fleet ? 'Fleet Import' : "Import",
                        success_msg: response?.data?.message
                    })
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                    trackActivity("Import Failed - Airworthiness Management", {
                        event_type: 'Attachment Failed',
                        page_title: fleet ? 'Fleet Import' : "Import",
                        error_msg: response?.data?.message
                    })
                }
            })

    }

    return (
        <Dialog
            open={true}
            onClose={toggleModalFn}
            className='console-management-modal'
            maxWidth={'md'}
        >
            <DialogTitle id="scroll-dialog-title">
                {title ? title : "Import File"}
            </DialogTitle>
            <DialogContent dividers={true}>
                <div style={{ width: '380px' }}>
                    <p style={{ marginBottom: '5px' }}>Refer the sample sheet,
                        <span className='download-sample-temp' onClick={() => downloadSample({ download: 'xlsx', download_sample: 'true' })} > DOWNLOAD  <ArrowDropDownIcon fontSize='small' /></span>
                    </p>
                    <div>
                        <DropzoneArea
                            filesLimit={1}
                            maxFileSize={104857600}
                            acceptedFiles={['.xlsx']}
                            showPreviewsInDropzone={false}
                            useChipsForPreview={true}
                            showPreviews={true}
                            dropzoneText={<p>Drag & Drop file Or Click Here </p>}
                            dropzoneClass="drag-drop-cnt"
                            maxWidth="sm"
                            showAlerts={['info', 'error']}
                            alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                            clearOnUnmount={true}
                            onChange={(file) => setFile(file)}
                        />
                    </div>
                </div>
                <span style={{ fontSize: '11px' }} className='files-upload-limit' > Note : Supported extension only ('.xlsx').</span>
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>CLOSE</Button>
                <Button disabled={isLoading || !file.length} onClick={importFile} color='primary' size='small' variant='contained'>
                    {isLoading ? <CircularProgress size={24} color='white' /> : 'SAVE'}
                </Button>
            </DialogActions>
            {isLoading ? <PageLoader /> : null}
        </Dialog>

    )
}

export default withRouter(ImportFormat) 